"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const styling_1 = require("../../../styling");
const styles_1 = tslib_1.__importStar(require("./styles"));
const ChevronDown_1 = tslib_1.__importDefault(require("../../Icons/ChevronDown"));
const useMediaQuery_1 = tslib_1.__importDefault(require("../../Hooks/useMediaQuery"));
function Carousel({ classes, itemsPerSlide = 3, gap = 10, children, vertical = true }) {
    const mergedClasses = (0, styling_1.useStyles)({ target: classes !== null && classes !== void 0 ? classes : {}, source: styles_1.default }, "carousel");
    const containerRef = (0, react_1.useRef)(null);
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(0);
    const [carouselDrivingDimension, setCarouselDrivingDimension] = (0, react_1.useState)(0);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const isTablet = (0, useMediaQuery_1.default)("screen and (max-width: 1023px)");
    const itemsPerSlideAdjusted = isTablet ? itemsPerSlide / 2 : itemsPerSlide;
    const lastSlideIndex = !Array.isArray(children) || children.length - itemsPerSlideAdjusted < 0
        ? 0
        : children.length - itemsPerSlideAdjusted;
    const isLastSlide = lastSlideIndex === currentIndex;
    const isFirstSlide = currentIndex === 0;
    const shouldRenderButtons = Array.isArray(children) && children.length > itemsPerSlideAdjusted;
    if (lastSlideIndex < currentIndex) {
        setCurrentIndex(lastSlideIndex);
    }
    const calculateCarouselDimension = (0, react_1.useCallback)(() => {
        if (!containerRef.current)
            return;
        const height = containerRef.current.offsetHeight;
        const width = containerRef.current.offsetWidth;
        if (vertical) {
            if (height === 0) {
                return;
            }
            const numberOfGaps = itemsPerSlideAdjusted - 1;
            setCarouselDrivingDimension((height - gap * numberOfGaps) / itemsPerSlideAdjusted);
        }
        else {
            if (width === 0) {
                console.error("Carousel component must be placed inside a fixed width container.");
                return;
            }
            const numberOfGaps = itemsPerSlideAdjusted - 1;
            setCarouselDrivingDimension((width - gap * numberOfGaps) / itemsPerSlideAdjusted);
        }
    }, [vertical, itemsPerSlideAdjusted, gap]);
    (0, react_1.useEffect)(() => {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!containerRef.current)
            return () => { };
        calculateCarouselDimension();
        const observer = new ResizeObserver(calculateCarouselDimension);
        observer.observe(containerRef.current);
        return () => {
            observer.disconnect();
        };
    }, [calculateCarouselDimension]);
    (0, react_1.useEffect)(() => {
        setTimeout(() => setIsLoading(false), 10);
    }, [carouselDrivingDimension]);
    const handleNext = () => {
        if (!Array.isArray(children)) {
            return;
        }
        setCurrentIndex((prev) => {
            const newIndex = prev + 1;
            if (newIndex > children.length - itemsPerSlideAdjusted)
                return prev;
            return newIndex;
        });
    };
    const handlePrev = () => {
        setCurrentIndex((prev) => {
            const newIndex = prev - 1;
            if (newIndex < 0)
                return prev;
            return newIndex;
        });
    };
    return (react_1.default.createElement("div", { className: mergedClasses.root, style: (0, styles_1.getRootStyles)(vertical) },
        react_1.default.createElement("button", { type: "button", className: mergedClasses.carouselButton, onClick: handlePrev, style: (0, styles_1.getButtonStyles)(vertical, isFirstSlide, shouldRenderButtons) },
            react_1.default.createElement(ChevronDown_1.default, { style: (0, styles_1.getChevronStyles)(vertical, shouldRenderButtons, "up") })),
        react_1.default.createElement("div", { ref: containerRef, className: mergedClasses.slidesWrapper },
            react_1.default.createElement("div", { className: mergedClasses.carouselSlidesWrapper, style: (0, styles_1.getCarouselSlidesWrapperStyles)(vertical, gap) }, react_1.Children.map(children, (child, idx) => (react_1.default.createElement("div", { className: mergedClasses.carouselItem, style: (0, styles_1.getCarouselSlideStyles)({
                    carouselDrivingDimension,
                    currentIndex,
                    isVertical: vertical,
                    gap,
                    isLoading,
                }) }, child))))),
        react_1.default.createElement("button", { type: "button", className: mergedClasses.carouselButton, onClick: handleNext, style: (0, styles_1.getButtonStyles)(vertical, isLastSlide, shouldRenderButtons) },
            react_1.default.createElement(ChevronDown_1.default, { style: (0, styles_1.getChevronStyles)(vertical, shouldRenderButtons, "down") }))));
}
exports.default = Carousel;
//# sourceMappingURL=index.js.map